<template>
  <div class="edit-studio-container">

    <main class="tab-content">

      <h2 class="item text-secondary">Footer content:</h2>
      <div class="btn-container">
        <span id="cancelUser" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <form class="form-container admin-studio-tab-pane fade show active" id="admin_user_info">
        <div class="field-sec">
          <label>Left image link:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.img_1" />
        </div>
        <div class="field-sec">
          <label>middle image1 link:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.img_2" />
        </div>
        <div class="field-sec">
          <label>middle image2 link:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.img_3" />
        </div>
        <div class="field-sec">
        </div>
        <div class="field-sec">
          <label>column 1 links:</label>
          <div class="field-sec array-links" v-for="item, i in fit20.blockToEdit.footer_col_2_links">
            <label>Text:</label>
            <input type="text" class="form-control" v-model="item.text" />
            <label>Link:</label>
            <input type="text" class="form-control" v-model="item.link" />
            <label v-if="i == 0 && fit20.selectedTabHref == 'country'">Studio contact page :</label>
            <input v-if="i == 0 && fit20.selectedTabHref == 'country'" type="text" class="form-control"
              v-model="item.contact_page" />
          </div>
        </div>
        <div class="field-sec ">
          <label>column 2 links:</label>
          <div class="field-sec array-links" v-for="item in fit20.blockToEdit.footer_col_3_links">
            <label>Text:</label>
            <input type="text" class="form-control" v-model="item.text" />
            <label>Link:</label>
            <input type="text" class="form-control" v-model="item.link" />
          </div>
        </div>
        <div class="field-sec">
          <label>Social media links:</label>
          <div class="field-sec array-links" v-for="item in fit20.blockToEdit.footer_col_4">
            <label>Link of <i :class="item.icon" style="color: #92d400; font-size: 20px"></i> :</label>
            <input type="text" class="form-control" v-model="item.link" />
          </div>
        </div>
      </form>
      <div class="btn-container">
        <span id="cancelUser2" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser2" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <br>
      <h3 class="text-secondary">Example:</h3>
      The example is for testing the content but may not be functional:
      <br>
      <section class="fit20-footer">
        <div id="footer_col_1" class="footer-col-1">
          <div id="footer_col_1_row2"></div>
          <div id="copyrights">{{ '© Copyright fit20 2009 - ' + new Date().getFullYear() }}</div>
          <img :src="'https://www.fit20.com' + fit20.blockToEdit.img_1" alt="proven" />
        </div>
        <div id="footer_col_2" class="footer-col-2">
          <div id="footer_col_2_links">
            <a class="footer-links" v-for="link in fit20.blockToEdit.footer_col_2_links" :href="'javascript:void(0)'">{{
              link.text
            }}</a>

          </div>
          <div id="footer_col_2_row2">
            <img class="img2" :src="'https://www.fit20.com' + fit20.blockToEdit.img_2" alt="gray" />
          </div>
        </div>
        <div id="footer_col_3" class="footer-col-3">
          <div id="footer_col_3_links">
            <a class="footer-links" v-for="link in fit20.blockToEdit.footer_col_3_links" :href="'javascript:void(0)'">{{
              link.text
            }}</a>

          </div>
          <div id="footer_col_3_row2">
            <img class="img2 img3" :src="'https://www.fit20.com' + fit20.blockToEdit.img_3" alt="gray2" />
          </div>
        </div>
        <div id="footer_col_4" class="footer-col-4">
          <a v-if="fit20.blockToEdit.footer_col_4[0].link" :href="fit20.blockToEdit.footer_col_4[0].link"
            target="_blank"><i :class="fit20.blockToEdit.footer_col_4[0].icon"
              style="color: #92d400; font-size: 35px"></i></a>
          <a v-if="fit20.blockToEdit.footer_col_4[1].link" :href="fit20.blockToEdit.footer_col_4[1].link"
            target="_blank"><i :class="fit20.blockToEdit.footer_col_4[1].icon"
              style="color: #92d400; font-size: 35px"></i></a>
          <a v-if="fit20.blockToEdit.footer_col_4[2].link" :href="fit20.blockToEdit.footer_col_4[2].link"
            target="_blank"><i :class="fit20.blockToEdit.footer_col_4[2].icon"
              style="color: #92d400; font-size: 35px"></i></a>
          <a v-if="fit20.blockToEdit.footer_col_4[3].link" :href="fit20.blockToEdit.footer_col_4[3].link"
            target="_blank"><i :class="fit20.blockToEdit.footer_col_4[3].icon"
              style="color: #92d400; font-size: 35px"></i></a>
        </div>
        <img class="footer-fit20-logo" src="https://www.fit20.com/files/images/Global/Global Logos/logo.png"
          alt="fit20 logo" />
      </section>
      <br>
      <div class="btn-container">
        <span id="cancelUser3" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser3" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
    </main>
  </div>
</template>

<script>

export default {
  name: 'Footer',
  props: ["fit20", "saveBlock", "cancelEditing"],
  methods: {
    getFooterBlockData: function (data) {
      const copyrights = document.getElementById('copyrights');
      const footerCol1Row2 = document.getElementById('footer_col_1_row2');
      const footerCol2Links = document.getElementById('footer_col_2_links');
      const footerCol2Row2 = document.getElementById('footer_col_2_row2');
      const footerCol3Links = document.getElementById('footer_col_3_links');
      const footerCol3Row2 = document.getElementById('footer_col_3_row2');
      const footerCol4 = document.getElementById('footer_col_4');

      let footerDataToUse = data;
    },
  },
  mounted() {
    this.getFooterBlockData(this.fit20.blockToEdit);
  },
  watch: {
    "fit20.blockToEdit": {
      deep: true, // Watch for changes in nested properties
      handler(newVal, oldVal) {
        if (newVal) {
          if (oldVal != newVal) {
            this.getFooterBlockData(this.fit20.blockToEdit);
          }
        }
      }
    }
  }
};
</script>

<style scoped>
.edit-studio-container {
  width: 100%;
  overflow: auto;
}

.tab-content {
  padding-top: 15px;
}

.tab-content h2 {
  margin-left: 10px;
}

.img-container img {
  border-radius: 15px;
  cursor: pointer;
  max-width: 150px;
}

.admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.form-container div {
  width: calc(100% / 2 - 30px);
}

.form-container label {
  display: block;
}

.studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.users-col {
  width: calc(100%);
}

.studio-machines {
  width: 100%;
}

.ex-member-container {
  margin-top: 10px;
}

.ex-member-flex {
  width: 100% !important;
}

.ex-member-item {
  width: 80% !important;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.ex-member-container img {
  margin-bottom: 7px;

}

.measure-div {
  position: relative;
}

.kg {
  position: absolute;
  right: 60px;
  bottom: 5px;
}

/* footer displayed Css */
.fit20-footer {
  padding-top: 25px;
  position: relative;
  width: 100%;
  display: flex;
  max-width: 1500px;
  margin: 0 auto;
}

.footer-col-1 {
  text-align: center;
  margin-top: -20px;
}

.footer-col-1,
.footer-col-2,
.footer-col-3 {
  width: 25%;
  font-size: 14px;
  display: flex !important;
  flex-direction: column;
  /* justify-content: space-around; */
}

#footer_col_3_row2 {
  display: flex !important;
  flex-direction: column;
  align-items: center;
  height: 100%;
}

.footer-col-2,
.footer-col-3 {
  margin: 0 auto;
}

#footer_col_2_links,
#footer_col_3_links {
  display: table;
  margin: 0 auto;
  /* min-height: 100px; */
}

#footer_col_2_row2,
#footer_col_3_row2 {
  text-align: center;
}

.fit20-footer .footer-links {
  display: block;
}

.fit20-footer img {
  width: 80%;
}

.img2 {
  width: 50% !important;
  /* margin-top: 25px; */
  max-width: 140px !important;
}

.img2.img3 {
  margin: auto 0;
}

.footer-col-4 {
  width: 25%;
  /* margin-right: 25px; */
  text-align: right;
  padding-top: 25px;
  margin-right: 20px;
}


.footer-col-4 i {
  padding: 8px;
  cursor: pointer;
}

.footer-col-4 i:hover {
  color: #009fe3 !important;
}

.footer-fit20-logo {
  width: 35% !important;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: -999;
}

#copyrights {
  margin-bottom: 20px !important;
}

@media only screen and (max-width: 1220px) {
  .footer-col-4 {
    padding-top: 15px !important;
  }

  .footer-col-4 i {
    font-size: 25px !important;
  }
}

@media only screen and (max-width: 1000px) {
  .footer-col-4 {
    padding-top: 5px !important;
  }

  .footer-col-4 a:first-child {
    margin-left: 25px !important;
  }

  .footer-col-4 i {
    font-size: 20px !important;
  }
}

@media only screen and (max-width: 800px) {
  #copyrights {
    font-size: 11px !important;
  }

  .footer-col-4 i {
    padding: 5px !important;
    font-size: 15 !important;
  }

  .footer-col-2,
  .footer-col-3 {
    font-size: 12px !important;
  }

  .footer-col-4 a:first-child {
    padding-left: 0px !important;
    margin-left: 5px !important;
  }

  #footer_col_2_links,
  #footer_col_3_links {
    min-height: 100px;
  }
}

@media only screen and (max-width: 500px) {
  .fit20-footer img {
    width: 50% !important;
  }

  #footer_col_2_row2,
  #footer_col_3_row2 {
    display: none !important;
  }

  .fit20-footer {
    flex-direction: column;
  }

  .footer-col-1,
  .footer-col-2,
  .footer-col-3,
  .footer-col-4 {
    width: 100%;
    text-align: center;
  }

  .footer-col-1,
  .footer-col-2,
  .footer-col-3 {
    padding-bottom: 15px;
  }

  .footer-col-4 a:first-child {
    padding-left: 0px !important;
    margin-left: 0px !important;
  }

  img.footer-fit20-logo {
    width: 100% !important;
    /* it is working fine on production*/
    position: relative !important;
    padding: 0px 0px 0px 40%;

    margin-top: -30px;
    z-index: -999;
  }
}
</style>
